import './image-slider.scss'

import Swiper, { Pagination } from 'swiper'

function init() {
  const swiper = new Swiper('.image-slider__slider', {
    modules: [Pagination],
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 8,
    pagination: {
      el: '.image-slider__pagination',
      clickable: true,
    },
    breakpoints: {
      1024: {
        slidesPerView: 4,
      },
    },
  })
}

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    init()
  },
  { once: true }
)
